
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import SkillSingleInputPlayground from '../../components/Skill/SingleInputOutput/SkillSingleInputPlayground';
import SkillOptions, { Option } from '../../components/Skill/SkillOptions';
import { COOKIE_OPTIONS } from '../../constants/cookies';
import { GPT_3_TOKEN_LENGTH } from '../../constants/gpt3';
import { SKILL_KEYWORDS_EXTRACTION_EXAMPLES } from '../../constants/skillExamples';
import { getFourRandomSkills, SKILL_KEYWORDS_EXTRACTION, SUMMARIZATION_SKILLS, } from '../../constants/skills';
import { useOptionCookie } from '../../hooks/useOptionCookie';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { deleteCookieClient } from '../../utils/cookieHelpers';
import { SkillProvider } from '../../utils/SkillContext';
const SkillKeywordsExtraction = ({ otherServices }: any) => {
    const { t, lang } = useTranslation('skill-keywords-extraction');
    const skillsGroup = SUMMARIZATION_SKILLS;
    const maxLength = 500 * GPT_3_TOKEN_LENGTH;
    const options = [
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
        { value: '6', text: '6' },
        { value: '7', text: '7' },
        { value: '8', text: '8' },
    ];
    const selectedKeywordsNumbers = useOptionCookie('numberOfElements', options, 2);
    const [selectedOption, setSelectedOption] = useState<Option>(options[2]);
    useEffect(() => {
        setSelectedOption(selectedKeywordsNumbers);
        deleteCookieClient(COOKIE_OPTIONS);
    }, [selectedKeywordsNumbers]);
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_keywords_extraction' description='meta_description_skill_keywords_extraction'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <ServiceGroupButtons serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_KEYWORDS_EXTRACTION} skillExamples={SKILL_KEYWORDS_EXTRACTION_EXAMPLES} skillGroup={skillsGroup}>
              <SkillSingleInputPlayground maxLength={maxLength} selectedOption={{
            numberOfElements: selectedOption.value,
        }}>
                <SkillOptions title={t('skill_keywords_extraction_subtitle')} options={options} selectedOption={selectedOption} setSelectedOption={setSelectedOption}/>
              </SkillSingleInputPlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillKeywordsExtraction;

    async function __Next_Translate__getStaticProps__19bb2fd5b8c__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/summarization/keywords-extraction',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b8c__ as getStaticProps }
  